const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../framework/core/mvvm/module_base";
import ClubUserInfoView from "./club_userInfo_view";
import ModelData, { IUserData } from "../../public/model_data";
import UserDataManager, { IUserCurrencyData } from "../../../manager/user_manager";
import PromiseUtility from "../../../utility/promiseUtility";
import { club_utils } from "../club_utils";

@ccclass
@moduleInit("ClubUserInfo")
export default class ClubUserInfo extends ModuleBase<ClubUserInfoView, null>  {

    constructor() {
        super()
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/club/module/club_userInfo';       
        this.viewType = ClubUserInfoView;
        this.needAnim = true
        this.needViewMask = true
        this.needDeferShow = true
    }

    protected onDeferShow(args){
        let id =args ? args.playerId : ModelData.instance.roleData.id
        if (!id) {
            return;
        }
        let self = this;

        let updateUserInfo = (cb)=>{
            self.getUserData(id,(userdata:IUserData)=>{
                self.view.updateUserInfo(userdata);
                cb();
            })
        }

        let updateUserMoney = (cb)=>{
            if (ModelData.instance.roleData.id == id) {
                UserDataManager.getCurrencyData(id,(currencyData: IUserCurrencyData)=>{
                    if (self.nodeIsValid) {
                        self.view.updateUserMoney(currencyData,true);
                        cb();
                    }
                },true,true)
            }else{
                self.view.updateUserMoney(null,false);
                cb();
            }
        }

        let updateLogo = (cb)=>{
            club_utils.reqClubIcon(this,(style:number)=>{
                this.view.updateLogo(style)
                cb()
            })
        }

        PromiseUtility.all([updateUserInfo,updateUserMoney,updateLogo]).then(()=>{
            self.show();
        })
    }

    @bindButtonClickEvent('hideBoxBtn')
    clickShowBank(){
        this.view.isShowBank(true)
    }

    @bindButtonClickEvent('showBoxBtn')
    clickHideBank(){
        this.view.isShowBank(false);
    }

    @bindButtonClickEvent('CloseBtn')
    clickButton(){
        this.hide();
    }
}